import type { BigNumber } from '@flipster/utils/num';

// 트리거 가격이 청산가에 근접(±2%)했는지 판정한다. 근접 시 Confirm 전에 청산 경고를
// 먼저 띄운다. native(iOS/Android) 및 TimeTriggerTpslModal과 동일한 기준.
// (Long: trigger <= liq * 1.02, Short: trigger >= liq * 0.98)
// 트리거 입력이 비어있거나(=삭제 흐름) 청산가가 없으면(0 이하) 경고하지 않는다.
export function isTriggerCloseToLiquidation({
  side,
  triggerPrice,
  liqPrice,
  isTriggerEmpty,
}: {
  side: 'Long' | 'Short';
  triggerPrice: BigNumber;
  liqPrice: BigNumber;
  isTriggerEmpty: boolean;
}): boolean {
  if (isTriggerEmpty) return false;
  if (liqPrice.isLessThanOrEqualTo(0)) return false;
  return side === 'Long'
    ? triggerPrice.isLessThanOrEqualTo(liqPrice.multipliedBy(1.02))
    : triggerPrice.isGreaterThanOrEqualTo(liqPrice.multipliedBy(0.98));
}

// Confirm 클릭 시 실행 흐름을 결정한다.
// - 청산가 근접이면 곧바로 실행하지 않고 청산 경고 다이얼로그만 띄운다. 실제 실행은
//   다이얼로그의 Proceed(=confirmTpsl)로 넘겨 사용자가 확인한 뒤에만 일어난다.
//   (다이얼로그를 여는 건 즉시 끝나므로 반환값 없음)
// - 근접이 아니면 즉시 실행하며, confirm의 Promise를 그대로 반환한다. 호출부(버튼)가
//   이 Promise를 await 해야 제출 중 버튼이 disabled/로딩 상태를 유지해 중복 제출을 막는다.
export function runTpslConfirm({
  isCloseToLiquidation,
  confirmTpsl,
  openLiquidationWarningDialog,
}: {
  isCloseToLiquidation: boolean;
  confirmTpsl: () => Promise<void> | void;
  openLiquidationWarningDialog: (onProceed: () => Promise<void> | void) => void;
}): Promise<void> | void {
  if (isCloseToLiquidation) {
    openLiquidationWarningDialog(confirmTpsl);
    return;
  }
  return confirmTpsl();
}
